export default {
  methods: {
    toPage(path) {
      this.$router.push(this.helpers.buildRoute(path)).catch(() => {})
    },
  },
}
